<template>
  <transition name="fade-bottom" @after-leave="destroy">
    <div
      v-show="show"
      :style="positionPx"
      class="lp-notification"
      :class="[`lp-notification--${type}`]"
      @mouseleave="startTimer"
      @mouseenter="clearTimer"
    >
      <!-- <div
        class="lp-notification-left"
        :style="{
          'background-image': backgroundImage,
          'background-color': emoji || image ? '#fdfdfd' : typeColor,
          'border-right': (emoji || image) && '1px solid #dfdfdf',
        }"
      >
        <lp-icon
          v-if="!image && !emoji"
          class="lp-notification-icon"
          :name="icon || typeIcon"
        />
        <span v-if="emoji && !image" class="lp-notification-emoji">{{
          emoji
        }}</span>
      </div>
      <div class="lp-notification-text-block">
        <span v-if="title" class="lp-notification-text-block-title">{{
          title
        }}</span>
        <span>{{ text }}</span>
      </div> -->
      <lp-alert
        :type="type"
        :title="title ? title : ''"
        :body="text ? text : ''"
      />
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Colors, Positions } from '../../models/enums'
import LpAlert from '../../components/alert'
import { typeIcon } from '../../components/message/model'

const colorTypes: { [key in Colors]?: string } = {
  [Colors.PRIMARY]: '#1A62FF',
  [Colors.SUCCESS]: '#07d85b',
  [Colors.DANGER]: '#F93155',
  [Colors.WARNING]: '#ffba00',
}

export default defineComponent({
  name: 'lp-notification',
  components: {
    'lp-alert': LpAlert,
  },
  data() {
    return {
      id: null,
      show: false,
      text: '',
      title: '',
      icon: '',
      emoji: '',
      image: '',
      duration: 5000,
      position: {} as { [key: string]: string },
      placement: Positions.TR,
      type: Colors.PRIMARY,
      timer: null as unknown as NodeJS.Timeout,
      onClose: () => {},
    }
  },
  computed: {
    backgroundImage(): string {
      return this.image ? `url(${this.image})` : ''
    },
    typeColor(): string {
      if (this.emoji) {
        return '#fbfbfb'
      }
      return colorTypes[this.type]!
    },
    positionPx() {
      const posPx: { [key: string]: string } = {}
      for (const key in this.position) {
        if (this.position.hasOwnProperty(key)) {
          posPx[key] = this.position[key] + 'px'
        }
      }
      return posPx
    },
    typeIcon(): string {
      return typeIcon[this.type]!
    },
  },
  mounted() {
    this.startTimer()
  },
  methods: {
    destroy() {
      this.$el.parentNode!.removeChild(this.$el)
    },

    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.show = false
          if (this.onClose) {
            this.onClose()
          }
        }, this.duration) as any
      }
    },

    clearTimer() {
      clearTimeout(this.timer)
    },
  },
})
</script>
